const table = {
  state: {
    selected:[],
    dialogVis:false,
    title: '',
    type_name: '',
    father_name: '',
    uid: '',
    data: [] ,
    // 为了分页加的
    total:0,
    pageSize:10,
    pageSizes:["10","20","50","100"],
    currentPage:1,
    companyId: ''
  },
  mutations: {
    SET_DATA: function(state, result) {
      state.data = result

    },
    EMPTY_DATA: function (state, result) {
      state.data = [];
    },
    SET_FATHER_NAME: function(state, result){
      state.father_name = result
    },
    SET_TYPE_NAME: function(state, result){
      state.type_name = result
    },
    SET_UID: function(state, result){
      state.uid = result
    },
    SET_TITLE: function (state, result) {
      state.title = result
    },
    SET_VIS: function (state, result) {
      state.dialogVis = result
    },
    ADD_DATA: function (state, result) {
      var newData = state.data;
      newData.push(result);
      state.data = newData
    },
    SET_TOTAL: function(state, result) {
      if(result){
        state.total = result
      }else{
        state.total = state.data.length
      }
    },
    SET_PAGESIZE: function(state, result) {
      state.pageSize = result
    },
    SET_PAGESIZES: function(state, result) {
      state.pageSizes = result
    },
    SET_CURRENTPAGE: function(state, result) {
      state.currentPage = result
    },
    SET_COMPANYID: function(state, result) {
      state.companyId = result
    }
  },
  actions: {
    // 从后台读取表格数据，config里面配置api,param,filter
    // api 为对应的后台接口
    // param为查询时附加的参数
    // filter 为过滤函数
    getDataFromServer: function({ commit }, config) {
      return new Promise(function(resolve, reject) {
        var api = config['api'];
        var param = config['param'];
        var filter = config['filter'];
        if(api&& typeof api == "function"){
          api(param).then(response => {
            commit('SET_DATA',response.data.data);
            commit('SET_TOTAL',response.data.data.length);
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        }else{
          console.log("API 设置不正确")
        }
      })
    },
    // 给表格保存数据,config里面配置api,formItem,filter
    // api 为对应的后台接口
    // formItem（可数组，可对象）
    // filter 为过滤函数
    setDataToServer: function({ commit }, config, tableItem){
      return new Promise(function(resolve, reject) {
        var api = config['api'];
        var formItem = config['formItem'];
        var filter = config['filter'];
        if(api(formItem)&& typeof api == "function"){
          api().then(response => {
            commit('ADD_DATA',tableItem);
            commit('SET_TOTAL');
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        }else{
          console.log("API 设置不正确")
        }
      })
    },
    // 给表格保存数据,config里面配置api,formItem,filter
    // api 为对应的后台接口
    // formItem（可数组，可对象）
    // filter 为过滤函数
    getItemFromServer: function({ commit }, config) {
      return new Promise(function(resolve, reject) {
        var api = config['api'];
        var formItem = config['formItem'];
        var filter = config['filter'];
        if (api && typeof api == "function"){
          api().then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    emptyData: function ({commit}) {
      commit('EMPTY_DATA')
    },
    setFather: function ({commit},data) {
      commit("SET_FATHER_NAME",data)
    },
    setUID:function ({commit}, data) {
      commit('SET_UID',data)
    },
    setType:function ({commit}, data) {
      commit('SET_TYPE_NAME',data)
    },
    setTitle:function ({commit}, data) {
      commit('SET_TITLE',data)
    },
    setVis: function ({commit}, data) {
      commit('SET_VIS',data)
    },
    setPageSize:function({commit},data){
      commit('SET_PAGESIZE',Number(data))
    },
    setCurrentPage:function({commit},data){
      commit('SET_CURRENTPAGE',Number(data))
    },
    setTotal:({commit},data)=>{
      commit('SET_TOTAL',data)
    },
    resetPage:({commit})=>{
      commit('SET_TOTAL',0);
      commit('SET_CURRENTPAGE',1);
      commit('SET_PAGESIZE',10);
      commit('SET_DATA',[])
    },
    //newadd
    getMenuData: function({commit},data) {
      commit('SET_DATA',data)
    },
    getRoleData: function({commit},data) {
      commit('SET_DATA',data)
    },
    setCompanyId: function({commit},data) {
      commit('SET_COMPANYID',data)
    }
  }
};
export default table
